<script>
  export default {
    name: 'll-pill',

    props: {
      /**
       * The text to render inside the pill
       */
      label: {
        type: String,
        default: '',
      },
      /**
       * The type of pill to render
       * Options: `normal` (default), `inverse`
       */
      type: {
        type: String,
        default: 'normal',
        validator(value) {
          return ['normal', 'inverse'].includes(value);
        },
      },
    },
  };
</script>

<template>
  <span :class="$style[`pill-${type}`]">
    {{ label }}
  </span>
</template>

<style lang="scss" module>
  .pill-normal,
  .pill-inverse {
    background: var(--color-ice-200);
    border-radius: 2px;
    color: var(--color-ice-700);
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    padding: 6px;
    text-transform: uppercase;
  }

  .pill-inverse {
    background: var(--color-ice);
    color: var(--color-white);
  }
</style>
